module.exports = __webpack_public_path__ + "static/media/p4.bfb83605.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/p4.jpeg
// module id = 589
// module chunks = 0